import "./index.css";

import { File, Sparkle } from "lucide-react";
import type { FC } from "react";

interface Props {
  fileName: string;
}

const LoaderExtractor: FC<Props> = ({ fileName }) => {
  return (
    <div className="py-20 border rounded-2xl flex items-center justify-center">
      <div className="flex flex-col items-center justify-center max-w-[40%]">
        <div className="relative mb-2">
          <div className="p-3 rounded-md bg-[#f1eaf5]">
            <Sparkle
              fill="#75458f"
              stroke="#75458f"
              className="h-6 w-6"
              strokeWidth={1}
            />
          </div>

          <Sparkle
            fill="#75458f"
            stroke="#75458f"
            className="absolute top-1 right-1 h-3 w-3 animate-twinkle"
            strokeWidth={1}
          />

          <Sparkle
            fill="#75458f"
            stroke="#75458f"
            className="absolute top-5 left-1 h-2.5 w-2.5 animate-twinkle-delayed"
            strokeWidth={1}
          />

          <Sparkle
            fill="#75458f"
            stroke="#75458f"
            className="absolute bottom-1 right-3 h-2 w-2 animate-twinkle-slow"
            strokeWidth={1}
          />
        </div>
        <h3 className="text-lg font-bold mb-1">Reading your menu</h3>
        <p className="text-gray-500 text-center mb-3">
          Our AI is extracting categories, dishes, and prices. This usually
          takes a few seconds.
        </p>
        <div className="w-full max-w-md bg-gray-200 rounded-full h-2 mt-6 mb-4">
          <div className="relative w-full max-w-md bg-muted rounded-full h-2 overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-[#75458f] to-transparent animate-[shimmer_1.5s_infinite]" />
          </div>
        </div>
        <div className="flex items-center justify-between w-full max-w-md gap-4">
          <div className="flex items-center gap-2 justify-center">
            <File className="w-4 h-4 text-gray-400" />
            <p className="text-sm text-gray-400 truncate max-w-[200px]">
              {fileName}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoaderExtractor;
